var icon = require('vue-svgicon')
icon.register({
  'ks-icon-money': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M45.6 75.5h4.6v-23h-4.6L41 54.8v4.6l4.6-2.3zm16.1-18.4a2.3 2.3 0 0 1 2.3 2.3v9.2a2.3 2.3 0 0 1-4.6 0v-9.2a2.3 2.3 0 0 1 2.3-2.3zm6.9 9.2v-4.6c0-5.06-3.08-9.2-6.9-9.2s-6.9 4.14-6.9 9.2v4.6c0 5.06 3.08 9.2 6.9 9.2s6.9-4.14 6.9-9.2zm11.5-9.2a2.3 2.3 0 0 1 2.3 2.3v9.2a2.3 2.3 0 0 1-4.6 0v-9.2a2.3 2.3 0 0 1 2.3-2.3zm6.9 9.2v-4.6c0-5.06-3.08-9.2-6.9-9.2s-6.9 4.14-6.9 9.2v4.6c0 5.06 3.08 9.2 6.9 9.2s6.9-4.14 6.9-9.2zm0-23a9.2 9.2 0 0 0 9.2 9.2v23a9.2 9.2 0 0 0-9.2 9.2H41a9.2 9.2 0 0 0-9.2-9.2v-23a9.2 9.2 0 0 0 9.2-9.2zm13.8 46V38.7H27.2v50.6zM18 29.5h92v69H18z" fill-rule="evenodd"/>'
  }
})
